import { gql } from 'apollo-angular';

/** Re-queue the selected certificates for AI processing. */
export const MUTATION_REPROCESS_SELECTED_WARRANTY_CERTIFICATES = gql`
  mutation reprocessSelectedWarrantyCertificates(
    $warrantyCertificateIds: [String!]!
  ) {
    reprocessSelectedWarrantyCertificates(
      warrantyCertificateIds: $warrantyCertificateIds
    ) {
      requeuedCount
      requeuedIds
    }
  }
`;
